var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-input-base-editor-index',{staticClass:"py-2",attrs:{"value":_vm.value,"options":_vm.editorOption,"rows":_vm.model.rows},on:{"input":function($event){return _vm.onChange($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }